import { render, staticRenderFns } from "./ConsultaBuroCredito.vue?vue&type=template&id=935059c0&scoped=true&"
import script from "./ConsultaBuroCredito.vue?vue&type=script&lang=js&"
export * from "./ConsultaBuroCredito.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaBuroCredito.vue?vue&type=style&index=0&id=935059c0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935059c0",
  null
  
)

export default component.exports